import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const MultiVendorEcommerceWebsitesInDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Multi-Vendor E-commerce Websites in Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Marketplace Power</Subheading>}
        heading={
          <Heading>
            Multi-Vendor <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we specialize in multi-vendor e-commerce websites
            in **Dubai**, building robust platforms that connect multiple
            sellers with buyers seamlessly. Create your marketplace with our
            expert solutions.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1518458028785-8fbcd101ebb9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor marketplace
          "https://images.unsplash.com/photo-1566241440091-ec10de8db2e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multiple stores/vendors
          "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business collaboration
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Build Your Marketplace"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Multi-Vendor Excellence in Dubai"
        description="We create platforms that empower multiple sellers."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Vendor Management",
            description: "Easy tools for multiple sellers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Scalable Design",
            description: "Grows with your vendor network.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom Features",
            description: "Tailored for your marketplace needs.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "Safe transactions for all parties.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Seamless shopping on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Dubai’s multi-vendor specialists.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Multi-Vendor Development Process"
        description={
          <Description>
            We build your marketplace with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Define your multi-vendor goals.</li>
              <li>Design: Create a user-friendly interface.</li>
              <li>Development: Build vendor dashboards and features.</li>
              <li>Integration: Add payments and shipping options.</li>
              <li>Testing: Ensure smooth vendor and buyer experiences.</li>
              <li>Launch: Deploy your thriving marketplace.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Marketplace development
          "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Business networking
          "https://images.unsplash.com/photo-1577401132920-f218ef9b01a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Development teamwork
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Multi-Vendor Wins in Dubai"
        description="Our platforms drive marketplace success."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Vendor Growth",
            description: "Added 150+ vendors in 5 months.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Launch",
            description: "Marketplace live in 3 weeks.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "User Feedback",
            description: "96% satisfaction from vendors and buyers.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Connect Sellers?</Subheading>}
        heading="Multi-Vendor E-commerce Websites in Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for multi-vendor e-commerce websites in
            Dubai. Build a powerful platform for multiple sellers—contact us
            today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1574362848149-11496d93a7c7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Multi-vendor concept
          "https://images.unsplash.com/photo-1560264280-88b68371db39?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Growth success
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
